
import { Component, Vue } from 'vue-property-decorator'
import Search from '@/components/search.vue'
import GlobalHeaderNav from './globalHeaderNav.vue'
import { openGlobalCustomerService } from '@/utils/global-customer-service'
@Component({
    name: 'globalHeader',
    components: {
        Search,
        GlobalHeaderNav
    }
})
export default class extends Vue {
    private isShowSearchDialog = false
    private searchDialog() {
        this.isShowSearchDialog = true
    }
    private closeMask() {
        this.isShowSearchDialog = false
    }
    get onlyShowNav() {
        const name = this.$route.name as string
        return ['feedback', 'SearchResult','allVideo', 'allDocument'].includes(name)
    }
    // 问题反馈
    private questionFeedback() {
        this.$jump('/feedback')
    }
    private openGlobalCustomerService() {
        openGlobalCustomerService()
    }
}

